import Typeahead from './Typeahead';

export { type TypeaheadProps } from './Typeahead';
export default Typeahead;
